import { createEventSettingImageFrameItem } from "./event.setting";

/**
 * @typedef {import("./event.setting").EventSettingImageFrameItem} EventSettingImageFrameItem
 */

/**
 * Event Media Gallery List Object Definition
 * @typedef {Object} EventMediaGalleryList
 * @property {EventSettingImageFrameItem[]} ImageFrames - An array of image frame setting items for the event
 */

/**
 * Create Event Media Gallery List Object
 * @returns {EventMediaGalleryList} The created Event Media Gallery List Object
 */
export function createEventMediaGalleryList() {
  const imageFrames = [];
  const imageFrameCount = createEventMediaConstants().imageFrameCount;
  for (let i = 1; i <= imageFrameCount; i++) {
    let imageFrameBase = createEventSettingImageFrameItem({
      active: false,
      order: i,
      type: "default",
    });
    imageFrameBase.id = "frame" + i;
    imageFrames.push(imageFrameBase);
  }
  // custom frames for special use
  let imageFrameCustom;
  imageFrameCustom = createEventSettingImageFrameItem({
    active: false,
    order: 101,
    type: "custom",
    name: "Social Banner Override",
    description:
      "Override the main banner image posted first in the carousel when boosting on socials. This image is not visible in the eventuator gallery. Use for specific social media campaigns.",
  });
  imageFrameCustom.id = "frameCustomSocialBannerOverride";
  imageFrames.push(imageFrameCustom);

  return imageFrames;
}

export function createEventMediaConstants() {
  const constants = {};
  constants.imageFrameCount = 12;

  return constants;
}
